// Configuration file for environment variables
// Note: In React apps, environment variables must be prefixed with REACT_APP_
// For now, we'll hardcode these values that are used across the app

export const config = {
  // S3 Configuration
  s3: {
    bucket: 'karini-demo-data-us-east-1',
    sopPath: 'demo-sop',
    o2cPath: 'sap-demo/edfr_o2c',
  },

  // API Endpoints
  api: {
    sopApi: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/sop',
    presignedUrl: 'https://aq2h8v8qu0.execute-api.us-east-1.amazonaws.com/prod/download-presigned-url',
    generateUrl: 'https://aq2h8v8qu0.execute-api.us-east-1.amazonaws.com/prod/generate-url',
    exceptions: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/exceptions',
    auditTrails: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/audit-trails',
    mtcExceptions: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/mtc-exceptions',
    orders: 'https://1zt2qdms1d.execute-api.us-east-1.amazonaws.com/dev/orders',
    return: 'https://1zt2qdms1d.execute-api.us-east-1.amazonaws.com/dev/return',
    login: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/login',
    resolve: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/resolve',
    paymentReconciliation: 'https://4cvm2mwttgvnxsbmqhwpkmd4ga0ytmbs.lambda-url.us-east-1.on.aws/',
    exceptionNotes: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/exception-notes',
    updateStatus: 'https://qczk14tyc2.execute-api.us-east-1.amazonaws.com/dev/update-status',
  },

  // SOP Keys
  sopKeys: {
    p2p: 'Regency_SOP.md',
    m2c: 'M2C_Exception_Management_Standard.md',
    orderProcessing: 'sop-order-processing.md',
    creditManagement: 'sop-credit-management-v1.md',
    cashApplication: '10_SOP_Cash_Application_Exception_Handling_v1.0.md',
  },

  // Webhook Configuration (P2P - Procure to Pay)
  p2p: {
    webhookUrl: process.env.REACT_APP_P2P_WEBHOOK_URL,
    apiToken: process.env.REACT_APP_P2P_API_TOKEN,
  },

  // Meter to Cash Webhook Configuration (M2C - Meter to Cash)
  m2c: {
    agent1WebhookRecipeId: process.env.REACT_APP_M2C_AGENT1_WEBHOOK_RECIPE_ID,
    agent1ApiToken: process.env.REACT_APP_M2C_AGENT1_API_TOKEN,
    agent2WebhookRecipeId: process.env.REACT_APP_M2C_AGENT2_WEBHOOK_RECIPE_ID,
    agent2ApiToken: process.env.REACT_APP_M2C_AGENT2_API_TOKEN,
  },

  // Credit Management Webhook Configuration (O2C - Credit Checks)
  creditManagement: {
    webhookRecipeId: process.env.REACT_APP_CREDIT_MANAGEMENT_WEBHOOK_RECIPE_ID,
    apiToken: process.env.REACT_APP_CREDIT_MANAGEMENT_API_TOKEN,
  },

  // Cash Application Webhook Configuration (O2C - Cash Application)
  cashApplication: {
    webhookRecipeId: process.env.REACT_APP_CASH_APPLICATION_WEBHOOK_RECIPE_ID,
    apiToken: process.env.REACT_APP_CASH_APPLICATION_API_TOKEN,
  },

  // Order Processing Webhook Configuration (O2C - Order to Cash)
  orderProcessing: {
    webhookRecipeId: process.env.REACT_APP_ORDER_PROCESSING_WEBHOOK_RECIPE_ID || 'ORDER_PROCESSING_RECIPE_ID',
    apiToken: process.env.REACT_APP_ORDER_PROCESSING_API_TOKEN,
  },
};

// Helper function to get S3 path
export const getS3Path = (folder, filename) => {
  return `s3://${config.s3.bucket}/${folder}/${filename}`;
};

// Helper function to get SOP S3 path
export const getSopS3Path = (sopKey) => {
  return `s3://${config.s3.bucket}/${config.s3.sopPath}/${sopKey}`;
};

export default config;
